import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PaginationButton from './button'

class Pagination extends Component {
  renderNextButton() {
    return <PaginationButton next onClick={ this.props.onNext } />
  }

  renderPrevButton() {
    return <PaginationButton prev onClick={ this.props.onPrev } />
  }

  render() {
    const { page, pageCount } = this.props
    const nextButton = page !== pageCount ? this.renderNextButton() : null;
    const prevButton = page > 1 ? this.renderPrevButton() : null;

    return (
      <div className="pagination">
        { prevButton }
        { nextButton }
      </div>
    )
  }
}

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/pagination/index.js